import React from "react";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import moment from "moment";

import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import { useTranslation } from "react-i18next";
import useClasses from "../../useClasses";
const styles = (theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingBottom: theme.spacing(1),
  },
  expand: {
    color: theme.palette.text.secondary,
    padding: theme.spacing(1),
    transform: "rotate(0deg)",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
});

function HistoryTabs(props) {
  const classes = useClasses(styles);
  const { t } = useTranslation();
  const { history, selectedBeepIndex, handleSelectedBeepIndex } = props;
  const time = moment.utc(history[selectedBeepIndex].time);
  const isBackDisabled = selectedBeepIndex === 0;
  const isNextDisabled = selectedBeepIndex === history.length - 1;
  const handleBack = () => {
    //console.log("Handle back");
    if (selectedBeepIndex - 1 >= 0) {
      //console.log("Selected - 1");
      handleSelectedBeepIndex(selectedBeepIndex - 1);
    }
  };
  const handleNext = () => {
    if (selectedBeepIndex + 1 <= history.length - 1) {
      handleSelectedBeepIndex(selectedBeepIndex + 1);
    }
  };
  return (
    <div className={classes.root}>
      <IconButton onClick={handleBack} disabled={isBackDisabled} size="large">
        <ArrowBackOutlinedIcon fontSize="small" />
      </IconButton>
      <Typography variant="subtitle2" color="textSecondary">
        {time.format("dddd D MMMM YYYY")} {t("scheduler.at")} {time.format("HH:mm")}
      </Typography>
      <IconButton onClick={handleNext} disabled={isNextDisabled} size="large">
        <ArrowForwardOutlinedIcon fontSize="small" />
      </IconButton>
    </div>
  );
}

export default HistoryTabs;
